module.exports = __webpack_public_path__ + "static/img/img16.6a7dd8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/126/img16.jpg
// module id = lvbN
// module chunks = 0